import { render, staticRenderFns } from "./CardDependents.vue?vue&type=template&id=4b44bd0c"
import script from "./CardDependents.vue?vue&type=script&lang=js"
export * from "./CardDependents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b44bd0c')) {
      api.createRecord('4b44bd0c', component.options)
    } else {
      api.reload('4b44bd0c', component.options)
    }
    module.hot.accept("./CardDependents.vue?vue&type=template&id=4b44bd0c", function () {
      api.rerender('4b44bd0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OrgChart/OrgChartForm/CardDependents.vue"
export default component.exports